import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';

import { fc } from 'i18n';
import { ITepOfficer } from 'types/tep';
import Input from 'core/react/general/form/Input';
import { selectedOfficerIdSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface IContactNumberProps {
  officer: ITepOfficer;
}

export const ContactNumber: FC<IContactNumberProps> = ({ officer }) => {
  const id = useSelector(selectedOfficerIdSelector);

  const { formState, control } = useFormContext<{ phone: string; remarks: string }>();

  const { errors } = formState;

  const isSelected = officer?.id === id;
  const error = errors.phone?.message;

  return isSelected ? (
    <Controller
      control={control}
      name="phone"
      rules={{ required: fc('please enter contact number') }}
      render={({ value, onChange }) => (
        <div className={styles.input}>
          <Input placeholder="enter contact number" value={value} onChange={onChange} />
          {/*TODO: error messages should be moved to corresponding form components when they are being refactored*/}
          {!!error && <div className={styles.error}>{error}</div>}
        </div>
      )}
    />
  ) : (
    <div>{officer.phone}</div>
  );
};
